




















import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop, Watch} from "vue-property-decorator";
import {Stripe, StripeElements, StripePaymentElement} from "@stripe/stripe-js";
import {BasketDto, PaymentMethodDto, StripePaymentInformationDto} from "@swagger";

@Component({
  components: {}
})
export default class PaymentMethodSelector extends BasicComponent {

  /* Whether the payment data is valid and complete */
  @Prop({type: Boolean, default: false}) value!: boolean;
  @Prop({type: Boolean, default: false}) bankTransfer: boolean;

  elements: StripeElements;
  paymentElement: StripePaymentElement;
  showBankItem: boolean = false;

  mounted() {
    this.initializeElements();
  }

  initializeElements() {
    if (!this.stripe || !this.paymentInformation) return;
    if (this.paymentElement != null) this.paymentElement.unmount();
    this.elements = this.stripe.elements({
      appearance: {
        theme: "stripe",
      },
      clientSecret: this.paymentInformation.paymentIntentSecret,
    });
    this.paymentElement = this.elements.create("payment", {
      layout: {
        type: "accordion",
        spacedAccordionItems: false,
        defaultCollapsed: true,
      },
    })
    this.paymentElement.mount(this.$refs.paymentElement as HTMLElement);
    this.showBankItem = true;
    this.paymentElement.on("change", (event) => {
      if (event.collapsed === false) {
        this.bankTransfer = false;
        this.emitPaymentMethod(this.getPaymentMethodByStripeName(event.value.type));
      }
      if (! this.bankTransfer) {
        this.$emit("input", event.complete);
      }
    });
  }

  onBankTransferChange(value: boolean) {
    if (value) {
      this.emitPaymentMethod(PaymentMethodDto.BANKTRANSFER);
      this.$emit("input", true);
      this.paymentElement.collapse();
    }
  }

  emitPaymentMethod(method: PaymentMethodDto) {
    this.$emit("paymentMethodChange", method);
  }

  getPaymentMethodByStripeName(name: string): PaymentMethodDto {
    return {
      "card": PaymentMethodDto.CREDITCARD,
      "sofort": PaymentMethodDto.SOFORT,
      "eps": PaymentMethodDto.EPS,
      "klarna": PaymentMethodDto.KLARNANOW,
      "bank_transfer": PaymentMethodDto.BANKTRANSFER,
    }[name];
  }

  get stripe(): Stripe {
    return this.$store.getters.stripe;
  }

  get paymentInformation(): StripePaymentInformationDto {
    return this.$store.getters.paymentInformation;
  }

  get basket(): BasketDto {
    return this.$store.getters.basket;
  }

  @Watch('stripe')
  onStripeChanged(value, oldValue) {
    this.initializeElements();
  }

  @Watch('paymentInformation')
  onPaymentInformationChanged(value, oldValue) {
    this.initializeElements();
  }

  @Watch('basket')
  onBasketChanged(value, oldValue) {
    this.elements?.fetchUpdates().then(({error}) => {
      if (error) {
        console.error("Error while fetching payment intent updates", error);
      }
    });
  }
}

